import angular from 'angular';
import barGraphStack from './barGraphStack';
import insurerComparisonGraph from './insurerComparisonGraph';
import './style.scss';

export default angular
  .module('components.insurerComparisonGraph', [])
  .component('barGraphStack', barGraphStack)
  .component('insurerComparisonGraph', insurerComparisonGraph).name;
